import { useMutation, useQueryClient } from "@tanstack/react-query";

import { addToolBlacklistItem } from "./api";
import type { AddToolBlacklistItemRequest, ToolBlacklistItem } from "./api";

// POST одного запрета. На успех инвалидируем список пары (org, role) — новый
// запрет появится в таблице без ручного refetch'а. Ключ включает role_name
// (тот же ключ, что у useToolBlacklist).
export function useAddToolBlacklistItem(): ReturnType<
  typeof useMutation<ToolBlacklistItem, Error, AddToolBlacklistItemRequest>
> {
  const queryClient = useQueryClient();
  return useMutation<ToolBlacklistItem, Error, AddToolBlacklistItemRequest>({
    mutationFn: (body) => addToolBlacklistItem(body),
    onSuccess: (_item, variables) => {
      void queryClient.invalidateQueries({
        queryKey: ["toolBlacklist", variables.role_name],
      });
    },
  });
}
